import React, { useEffect } from "react";
import { Spin } from "antd";
import { useCompositeState, callApi } from '../../../../utils';
import { cloneDeep } from "lodash";

const prefixCls = 'eh-newselectmodal-personinfo';

const labelFieldsMap = {
  contactName: '姓名',
  contactEnName: '别名',
  contactToken: '手机',
  contactShortToken: '短号',
  telephone: '座机',
  workEmail: '邮箱',
  departments: '部门',
  labels: '标签',
  employeeNo: '工号',
  remark: '备注',
  jobPositions: '岗位'
}

const PersonInfo = ({ detail }) => {
  const { id: userId, detailId } = detail;

  const [state, setState] = useCompositeState({
    loading: false,
    curDetail: {}
  })

  const { loading, curDetail } = state;

  useEffect(() => {
    const { namespaceId, organizationId } = window.$$context;
    setState({
      loading: true
    })
    callApi({
      api: '/org_v6/getContactDetail',
      prefixCls: '/api/evh',
      data: {
        detailId,
        userId,
        organizationId,
        namespaceId
      },
      success: (res) => {
        setState({
          curDetail: res,
        })
      },
      complete: () => {
        setState({
          loading: false,
        })
      }
    })
  }, [])

  const {
    departments = [],
    jobPositions = [],

    departmentId,
    fixedFieldIndices = []
  } = curDetail;

  const memberDeps = cloneDeep(departments);
  const primaryDepIndex = memberDeps.findIndex(dep => dep.id === departmentId);
	// 主部门移到第一位
  if (primaryDepIndex > -1) {
    const temp = memberDeps[primaryDepIndex];
    memberDeps.splice(primaryDepIndex, 1);
    memberDeps.unshift(temp);
  }


  let contentList = [];

  fixedFieldIndices.forEach(item => {
    switch(item) {
      case 'contactName':
      case 'contactEnName':
      case 'contactToken':
      case 'contactShortToken':
      case 'telephone':
      case 'workEmail':
      case 'employeeNo':
      case 'remark':
        if(curDetail[item]) {
          contentList.push({
            label: labelFieldsMap[item],
            content: curDetail[item],
          })
        }
      break;
      case 'departments':
      case 'labels':
        if(curDetail[item] && curDetail[item].length) {
          contentList.push({
            label: labelFieldsMap[item],
            content: `${curDetail[item].map(item => item.name).join(' | ')}`
          })
        }
        break;
      case 'jobPositions':
        if(jobPositions && jobPositions.length) {
          contentList.push({
            label: labelFieldsMap[item],
            content: `${jobPositions.map(item => item.jobPositionName).join(' | ')}`
          })
        }
        break;
      default:
        break;
    }
  })


  return (
    <Spin spinning={loading}>
      {contentList.map(item => (
        <div className={`${prefixCls}-item`}>
          <span>{`${item.label}: `}</span>
        <span>{item.content}</span>
      </div>
      ))}
    </Spin>
  )
}

export default PersonInfo;
